import { resolveImagePath } from '@/utils/imageMap';

export function Header() {
  return (
    <header className="relative z-10">
      {/* Main header area with semi-transparent background positioned over hero image */}
      <div 
        className="absolute top-0 left-0 right-0 bg-white bg-opacity-90 shadow-sm"
        style={{ 
          background: 'linear-gradient(to bottom, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.85))'
        }}
      >
        <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
          {/* Logo with integrated phone number */}
          <div className="flex items-center">
            <a href="/" className="block">
              <img 
                src={resolveImagePath('/images/logo.jpg')}
                alt="Dang's Vietnamese Restaurant - Bend Oregon - 541-385-8888"
                className="h-16 w-auto filter drop-shadow-sm"
              />
            </a>
          </div>

          {/* Navigation Menu */}
          <nav className="flex items-center space-x-6">
            <a 
              href="/menu"
              className="text-gray-700 hover:text-gray-900 font-semibold text-sm tracking-wider uppercase transition-colors"
            >
              MENU
              <span className="ml-1 text-gray-500">»</span>
            </a>
            <a 
              href="/location"
              className="text-gray-700 hover:text-gray-900 font-semibold text-sm tracking-wider uppercase transition-colors"
            >
              LOCATION
            </a>
          </nav>
        </div>
      </div>
      
      {/* Spacer to account for absolute positioned header */}
      <div className="h-20"></div>
    </header>
  );
}